/*
Videos
*/
$('.video-trigger').on('click', function (e) {
    e.preventDefault();
    $('#player-container').html(embeds[$(this).data('embed')]);
    youtubeIframeAssistant();
    let iframe = $('#player-container').find('iframe');
    iframe[0].src += "&autoplay=1";
    $('#video-player').addClass('shown');
});

/*
Product guide seciton
*/
$('#product-guide-switcher .guide-label').on('click', function (e) {
    e.preventDefault();
    $('.guide-label, .guide-content').removeClass('active');
    $(this).addClass('active');
    $($(this).data('target')).trigger('click');
    $('#active-tab-label').text($(this).text());
    $('.dropdown').removeClass('is-open');
});

$('.guide-content table').wrap('<div class="scrolling-table"/>');

/*
Add to cart
*/
// var totesMin = 500;
// var totesClass = 'is-totes';
var $qtyRow = $('#add-to-cart-quantity-row');
var $qtyField = $qtyRow.find('.qty');
// var $totesDisclaimer = $('#add-to-cart-totes-disclaimer');
var $priceDetails = $('#price-details');
var $itemTotal = $('.item-summary .total');
var $btn = $('#add-to-cart');
var $oosMsg = $('#oos-message');
var unitOfMeasurement = $('.product-summary .price .uom').text();
var unitOfMeasurementPlural = unitOfMeasurement ? unitOfMeasurement + 's' : '';
var updateTotals = function () {
    if (!$qtyField.val()) return;
    let p = {
        product_price: productData.price,
        num_decimals: productData.currencyDecimals,
        currency_symbol: productData.currencySymbol
    };
    $itemTotal.text(p.currency_symbol + parseFloat(p.product_price * $qtyField.val()).toFixed(p.num_decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ","));
}
function shallowEqual(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (object1[key] !== object2[key]) {
            return false;
        }
    }

    return true;
}

function combineArrays(arrays) {
    if (!arrays || arrays.length === 0) {
        return [];
    }

    const results = [];
    const indices = Array(arrays.length).fill(0);

    while (true) {
        const combination = indices.map((index, arrayIndex) => arrays[arrayIndex][index]);
        results.push(combination.join(','));

        let i = indices.length - 1;
        while (i >= 0 && indices[i] === arrays[i].length - 1) {
            indices[i] = 0;
            i--;
        }

        if (i < 0) {
            break;
        }

        indices[i]++;
    }

    return results;
}

function arrayDiff(arr1, arr2) {
    const set2 = new Set(arr2);
    const diff1 = arr1.filter(x => !set2.has(x));
    const set1 = new Set(arr1);
    const diff2 = arr2.filter(x => !set1.has(x));
    return [...diff1, ...diff2];
}

function validateOptions(groupIndex) {
    // if this option come from the last group, we have a completed set
    if (groupIndex === $('.attribute').length - 1) {
        console.log('do nothing');
        return;
    }
    // if this option is not in the last group, re-assess downstream groups
    let selectedValues = [];
    let realCombinations = [];
    $(".variations_form").data('product_variations').forEach(variant => {
        realCombinations.push(Object.values(variant.attributes).join(','));
    });
    $('.attribute').each(function (index) {
        if (index <= groupIndex) {
            selectedValues.push($(this).find('.attribute-option input:checked').val());
            return;
        }
        $(this).find('.attribute-option').each(function () {
            $(this).removeClass('disabled');
            $(this).find('input').prop('disabled', false);

            let proposedCombination = selectedValues.concat([$(this).find('input').val()]).join(',');
            if (!realCombinations.includes(proposedCombination)) {
                $(this).addClass('disabled');
                $(this).find('input').prop('disabled', true).prop('checked', false);
            }
        });
    });

    // // create an array of combinations from the actual variants admin has created
    // let availableVariantCombinations = [];
    // $(".variations_form").data('product_variations').forEach(variant => {
    //     let options = [];
    //     let keys = Object.keys(variant.attributes);
    //     keys.forEach(key => {
    //         options.push(variant.attributes[key]);
    //     })
    //     availableVariantCombinations.push(options.join(','));
    // });
    // // create an array of combinations from the displayed variants, which is every option for every attribute
    // let optionGroups = [];
    // $('.attribute-options').each(function () {
    //     let arr = [];
    //     $(this).find('input').each(function () {
    //         arr.push($(this).val())
    //     });
    //     optionGroups.push(arr);
    // });
    // const displayedCombinations = combineArrays(optionGroups);
    // // arrayDiff the two to find the combinations that don't exist
    // const impossibleCombinations = arrayDiff(displayedCombinations, availableVariantCombinations);

    // console.log(impossibleCombinations);
    // console.log(selectedValues);

    // $('.attribute').each(function (index) {
    //     if(index <= groupIndex) {
    //         return;
    //     }

    //     impossibleCombinations.forEach(combination => {
    //         let arr = combination.split(',');

    //         if (arr[index] === value) {
    //             arr.forEach(k => {
    //                 if (k !== value) {
    //                     $(`input[value="${k}"]`).prop('checked', false).prop('disabled', true).closest('label').addClass('disabled');
    //                 }
    //             })
    //             return;
    //         }
    //     });
    // });
    return;

    const attribute = $option.attr('name');
    optionGroups = [];
    // reset
    $('.attribute-option input').prop('disabled', false);
    $('.attribute-option').removeClass('disabled');
    $('.attribute').each(function () {
        let arr = [];
        if ($(this).find('select').attr('name') === attribute) {
            arr.push($option.val());
        } else {
            $(this).find('input').each(function () {
                arr.push($(this).val())
            });
        }
        optionGroups.push(arr);
    });
    const possibleCombinations = combineArrays(optionGroups);
    possibleCombinations.forEach(combination => {
        if (impossibleCombinations.includes(combination)) {
            let valuesToDisable = combination.split(',');
            valuesToDisable.forEach(value => {
                if (value !== $option.val()) {
                    $(`input[value="${value}"]`).prop('checked', false).prop('disabled', true).closest('label').addClass('disabled');
                }
            })
        }
    });
}

function onVariationUpdate() {
    const $form = $(".variations_form");
    const variations = $form.data('product_variations');
    const $attributes = $form.find('select[name^="attribute_"]');
    let selectedAttributes = {};
    $('p.stock').remove();
    $attributes.each(function () {
        selectedAttributes[$(this).attr('name')] = $(this).val();
    });
    variations.forEach(variation => {
        // find a matching variant
        if (shallowEqual(variation.attributes, selectedAttributes)) {
            let v = variation;
            let showMessage = false;
            window.productData.price = v.display_price;
            if (v.is_in_stock && v.is_purchasable) {
                $('[name="variation_id"]').val(v.variation_id);
                $btn.attr('disabled', false);
                // user can purchase, but there's a message to show
                // the message exists when the backorders = allow, but notify customer
                // it's empty if backorders = allow
                if (v.availability_html) showMessage = true;
            } else {
                // out of stock
                $btn.attr('disabled', true);
                showMessage = true;
            }
            if (showMessage) {
                $(v.availability_html).insertBefore('#add-to-cart-quantity-row');
                if (v.backorders_allowed && v.backorder_message !== '') {
                    $('p.stock').append(' ' + v.backorder_message);
                }
            }
            updateTotals();
            return;
        }
    });
}

// variable product
if ($('.variations_form').length) {

    $(".variations_form").on("show_variation", function () {
        $('p.stock').remove();
        onVariationUpdate();
    });

    // on radio button change
    $(document).on('change', '.attribute-option input', function () {
        // for each checked radio button we reflect the same changes to select dropdowns
        $('.attribute-option input:checked').each(function (index, element) {
            const radio = $(element);
            const radioName = radio.attr('name');
            const radioValue = radio.attr('value');
            $('select[name="' + radioName + '"]').val(radioValue).trigger('change');
        });
        validateOptions(Number($(this).closest('.attribute').data('index')));
        onVariationUpdate();
    });

    // auto-select the first option when admin hasn't selected a default
    let haveDefaultOption = false;
    $('.attribute-options').each(function () {
        if ($(this).find('input:checked').length) {
            haveDefaultOption = true;
        }
    });
    if (!haveDefaultOption) {
        const inStockVariant = $(".variations_form").data('product_variations').find(variant => {
            return variant.is_in_stock && variant.is_purchasable;
        })
        const keys = Object.keys(inStockVariant.attributes);
        $(`input[name="${keys[0]}"][value="${inStockVariant.attributes[keys[0]]}"]`).prop('checked', 'checked');
        $(`select[name="${keys[0]}"]`).val(inStockVariant.attributes[keys[0]]).trigger('change');
    }

    validateOptions(0);
    onVariationUpdate();

} else {

    // simple product
    updateTotals();
}

// qty changes
$qtyField.on('change keyup', function () {
    updateTotals();
});

$('.qty-adjust').on('click', function (e) {
    e.preventDefault();
    let currentQty = Number($qtyField.val());
    if ($(this).hasClass('up')) {
        let newQty = currentQty + 1;
        $qtyField.val(newQty);
    } else {
        if (currentQty === 1) {
            return;
        }
        let newQty = currentQty - 1;
        $qtyField.val(newQty);
    }
    updateTotals();
});

$('#add-to-cart').on('click', function () {
    $(this).addClass('working');
});
